import React from "react";
import { Tag } from "antd";
import { getCategoryMeta } from "../../constants/activityCategories";

const CategoryBadge = ({ category, className = "" }) => {
  const meta = getCategoryMeta(category);

  return (
    <Tag color={meta.color} className={`font-custom m-0 ${className}`}>
      {meta.label}
    </Tag>
  );
};

export default CategoryBadge;
